import { Component, Input, OnInit, SimpleChanges } from '@angular/core';

@Component({
  selector: 'kve-editor-input-header',
  templateUrl: './editor-input-header.component.html',
  styleUrls: ['./editor-input-header.component.scss']
})
export class EditorInputHeaderComponent implements OnInit {
  @Input() title:string;
  @Input() toolTip:string;
  info:boolean = false;
  constructor() { }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    //Called before any other lifecycle hook. Use it to inject dependencies, but avoid any serious work here.
    //Add '${implements OnChanges}' to the class.
    if(changes["toolTip"]){
      this.info = true;
    }
  }

}
